// extracted by mini-css-extract-plugin
export default {"label":"SWIndividualCustomerForm_label__xnKvX","required":"SWIndividualCustomerForm_required__Hmz8N"};